import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
//   import { Carousel } from 'react-responsive-carousel'
import { Carousel } from 'react-bootstrap';
  import carousel_1 from '../img/carousel-1.jpg';
  import carousel_2 from '../img/carousel-2.jpg';
  import carousel_4 from '../img/carousel-4.jpg';
  import carousel_5 from '../img/carousel-5.jpg';
  // import Video from '../video/SL_LIVE_19_Final_Video.mp4';
  import Client from "../contentful";
  import { Player,ControlBar,BigPlayButton  } from 'video-react';
import "../../node_modules/video-react/dist/video-react.css";

export default class CarouselComponent extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
        
                slider:[],
                captions:[],
                sliderButtons:[],
                carousel:[]
          
        }
    }

   

    formatData(items) {
        let tempItems = items.map(item => {
    
          let id = item.sys.id;
          let carousel =[]
        let slider = []
        // slider.push(Video)
        // let video={
        //   image: Video,
        //   url:'',
        //   title:''
        // }
        // carousel.push(video)
        item.fields.slider.map(slideritem => {
          console.log(slideritem?.fields?.file?.url)
          let image = slideritem?.fields?.file?.url
         
          slider.push(slideritem?.fields?.file?.url)

          // item.fields.sliderButtons.map(item=>{
          //   // console.log(item?.url)
          //   let url=item?.url
          //   let title = item?.title
          //   let set={
          //     image:image,
          //     url:url,
          //     title:title
          //   }
          //   console.log(set,'jjjjjjjjjj')
          // })
        })
        let sliderButtons = item.fields.sliderButtons
        for(var i=0; i < sliderButtons.length; i++){
          let set={
            image: item.fields.slider[i]?.fields?.file?.url,
            url:item.fields.sliderButtons[i].url,
            title:item.fields.sliderButtons[i].title
          }
          console.log(set,'jjjjjjjjjj')
          carousel.push(set)
        }
        console.log(carousel)
       
   
        // item.fields.sliderButtons.map(slideritem => {
        //   console.log(slideritem?.fields?.description)
        //   captions.push(slideritem?.fields?.description)
        // })
        
        
       
        this.setState({
            slider:slider,
            
            carousel:carousel
        })

        console.log(this.state.carousel)
         
         
    
       
        
          
          
        });
        return tempItems;
        console.log(items)
      }
      
        componentDidMount() {
      
          Client.getEntries({
            content_type : "homePage"
          })
          .then(response=>{
            console.log(response.items)
            this.formatData(response.items)
          })
        }



        

    render() {
      
        return(
          
            <div>
            

         

    <Carousel interval="10000">
    {
        this.state.carousel.map( item => (
  <Carousel.Item>
{

item?.image.includes("mp4") ? 
(

  <Player  
 
  autoPlay
  muted
  src={item?.image}
>
<ControlBar  disableCompletely ></ControlBar>
<BigPlayButton position="center" />
  </Player>

) :
(
  <div>
  <img
  className="d-block w-100"
  src={item?.image}
  alt=""
/>
<div className="centerr">
<Carousel.Caption>

<Link to={item?.url}>
  <div className="caption_box">
  <h1 className="caption_box_text">{item?.title}</h1>
  </div>
  </Link>
  
  </Carousel.Caption>
  </div>
  
</div>
   
)
    }



  </Carousel.Item>

     ))
    }
    
  </Carousel>

            </div>
            
        )
    }
}